"use client";

import React from "react";
import { SpacingType, sectionVariants, ButtonStyleType } from "@/types";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import { Badge } from "@/components/ui/badge";
import parse from "html-react-parser";
import Image from '@/components/ui/Image';
import { SectionWrapper } from "../components/SectionWraper";

interface FeatureItem {
  icon?: string;
  image?: string;
  imageAltText?: string;
  badge?: string;
  title?: string;
  content?: string;
  hasButton?: boolean;
  buttonText?: string;
  buttonLink?: string;
  buttonStyle?: ButtonStyleType;
}

interface Feature28Props {  
  darkMode?: boolean;
  spacing?: SpacingType;
  variant?: sectionVariants;
  usedInPageNav?: boolean;
  pageNavTitle?: string;
  themeChangeOnScroll?: boolean;
  badge?: string;
  title?: string;
  content?: string;
  hasButton?: boolean;
  buttonText?: string;
  buttonLink?: string;
  buttonStyle?: ButtonStyleType;
  items?: FeatureItem[];
  attributes?: React.HTMLProps<HTMLElement>;
}
const Feature28 = ({
  darkMode = false,
  spacing,
  variant = 'A',
  usedInPageNav = false,
  pageNavTitle = "Feature 10",
  themeChangeOnScroll = false,
  badge,
  title,
  content,
  hasButton,
  buttonText,
  buttonLink,
  buttonStyle,
  items,
  attributes,
}: Feature28Props) => {

  return (
    <SectionWrapper
      usedInPageNav={usedInPageNav}
      pageNavTitle={pageNavTitle}
      themeChangeOnScroll={themeChangeOnScroll}
      spacing={spacing}
      variant={variant}
      darkMode={darkMode}
      heroSection={false}
      componentName="feature10"
      attributes={attributes}
    > 
      <div className="container"> 
        <div className="mb-10 flex flex-col items-center gap-6 md:gap-12 md:mb-20" data-aos="fade-up">
          {badge && (
            <Badge variant="outline" bold>
              {badge}
            </Badge>
          )}
          {title && (
            <h2 className="text-center md:max-w-[500px] lg:max-w-[800px] md:mx-auto">
              {parse(title)}
            </h2>
          )}
          {content && (
            <div className="paragraph-lg text-muted-foreground text-center md:max-w-[65ch] mx-auto">
              {parse(content)}
            </div>
          )}
          {hasButton && (
            <div className="flex flex-col text-center gap-3">
              <Button asChild variant={buttonStyle} size="lg" className="w-full lg:w-auto">
                <Link href={buttonLink ?? ""}>
                  {buttonText}
                </Link>
              </Button>
            </div>
          )}
        </div>  
        
        <div className="mx-auto grid gap-14 lg:gap-10 lg:grid-cols-3" data-aos="fade-up" data-aos-delay={100}>
          {items && items.length > 0 && items?.slice(0, 3).map((item, index) => (
            <div key={index} className="flex flex-col gap-6">
              <div className="relative">
                <Image
                  src={item.image ?? ""}
                  alt={item.imageAltText ?? ""}
                  title={item.imageAltText ?? ""}
                  width={840}
                  height={560}
                  className="aspect-[840/560] object-cover w-full"
                />
              </div>
              {item.badge && (
                <Badge variant="outline" bold>
                  {item.badge}
                </Badge>
              )}
              {item.title && (
                <h5 className="">
                  {item.title}
                </h5>
              )}
              {item.content && (  
                <div className="paragraph-base">
                  {parse(item.content ?? "")}
                </div>
              )}
              {item.hasButton && (
                <Button asChild variant={item.buttonStyle} size="lg" className="w-fit self-start">
                  <Link href={item.buttonLink ?? ""}>
                    {item.buttonText}
                  </Link>
                </Button>
              )}
            </div>
          ))}
        </div>
      </div>
    </SectionWrapper>
  );
};

export { Feature28 };